import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import Checkbox from "components/Checkbox";

import styles from "forms/forms.css";

const CheckboxField = ({
  children,
  className,
  field,
  form,
  isDisabled,
  isRequired,
  label,
  onChange,
}) => (
  <div className={cx(styles.field, className)}>
    <Checkbox
      isChecked={!!field.value}
      isRequired={isRequired}
      isDisabled={isDisabled}
      label={label}
      onChange={() => {
        if (onChange) onChange(!field.value);
        form.setFieldValue(field.name, !field.value);
      }}
    >
      {children}
    </Checkbox>
  </div>
);

CheckboxField.propTypes = {
  field: PropTypes.shape({
    value: PropTypes.bool,
    name: PropTypes.string,
  }),
  form: PropTypes.shape({
    setFieldValue: PropTypes.func,
  }),
  onChange: PropTypes.func,
  className: PropTypes.string,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default CheckboxField;
